import { render, staticRenderFns } from "./LearningPath.vue?vue&type=template&id=f613d9fa&scoped=true&"
import script from "./LearningPath.vue?vue&type=script&lang=ts&"
export * from "./LearningPath.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPath.vue?vue&type=style&index=0&id=f613d9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f613d9fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f613d9fa', component.options)
    } else {
      api.reload('f613d9fa', component.options)
    }
    module.hot.accept("./LearningPath.vue?vue&type=template&id=f613d9fa&scoped=true&", function () {
      api.rerender('f613d9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/LearningPath.vue"
export default component.exports